import React from 'react';

const ForSchools = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      width={48}
      height={51}
      viewBox='0 0 48 51'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M2.50086 41.0469C2.50086 41.0469 0.895845 45.3562 2.63664 50.0989H41.2799C41.2799 50.0989 42.849 44.9263 41.3704 41.0469H2.50086Z'
        fill='#A0C9CF'
      />
      <path
        d='M41.3701 41.0521L40.7416 39.8984L35.5121 41.0521H41.3701Z'
        fill='#80B6BA'
      />
      <path
        d='M2.50043 41.0486L4.39783 39.8125C4.39783 39.8125 21.5197 41.0486 21.4592 41.0486C21.3986 41.0486 2.50043 41.0486 2.50043 41.0486Z'
        fill='#80B6BA'
      />
      <path
        d='M3.00189 41.0469H41.1613'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.00189 50.1016H41.1613'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2.89763 41.5938C2.89763 41.5938 1.72267 45.4891 2.89763 49.2851'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.52361 41.5938C3.52361 41.5938 2.34865 45.4891 3.52361 49.2851'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M40.9116 49.2851C40.9116 49.2851 42.0867 45.3898 40.9116 41.5938'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M40.2851 49.2851C40.2851 49.2851 41.4601 45.3898 40.2851 41.5938'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M39.6811 45.4228L37.7737 43.6426L37.7737 43.6172H5.99965L4.06488 45.4228L5.99965 47.1347H37.7737L37.7737 47.1106L39.6811 45.4228Z'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M42.417 38.8669L42.417 33.2422L36.9655 33.381L36.2587 35.3025L37.026 41.0507L42.417 38.8669Z'
        fill='#F4E6DC'
      />
      <path
        d='M38.8935 38.7298C38.5682 38.3059 38.3345 37.8012 38.2621 37.2657C38.1974 36.7877 38.2693 36.3009 38.4367 35.8517C38.6142 35.3757 38.8882 34.9429 39.2056 34.5519C39.545 34.134 39.9362 33.7619 40.3522 33.425C40.4129 33.3759 40.4755 33.3289 40.5373 33.2812L36.9655 33.3723L36.2587 35.2938L37.026 41.0419L40.2004 39.756C39.6771 39.5475 39.2381 39.179 38.8935 38.7298Z'
        fill='#EDD5C5'
      />
      <path
        d='M36.6176 35.0666C37.0885 34.9231 37.5622 34.7908 38.0364 34.66C38.5104 34.5289 38.9866 34.4069 39.4618 34.28L40.8928 33.9233C41.3709 33.8087 41.8495 33.6955 42.3307 33.5938C41.8597 33.7374 41.3861 33.8697 40.9119 34.0005L39.4865 34.3802C39.0094 34.4988 38.5334 34.6222 38.0553 34.7368C37.5772 34.8515 37.0988 34.9645 36.6176 35.0666Z'
        fill='#DDB69B'
      />
      <path
        d='M36.5971 35.796C37.0767 35.6413 37.5591 35.4976 38.042 35.3556C38.5248 35.2134 39.01 35.0801 39.4939 34.9418L40.9519 34.5512C41.4391 34.4252 41.9267 34.3008 42.4171 34.1875C41.9376 34.3423 41.4552 34.486 40.9724 34.6281L39.5204 35.0417C39.0343 35.1715 38.5495 35.3063 38.0623 35.4322C37.5751 35.5581 37.0875 35.6826 36.5971 35.796Z'
        fill='#DDB69B'
      />
      <path
        d='M36.6171 36.4338C37.0881 36.2903 37.5617 36.1579 38.0359 36.0271C38.5099 35.8961 38.9861 35.7741 39.4613 35.6472L40.8924 35.2905C41.3705 35.1759 41.849 35.0627 42.3302 34.9609C41.8593 35.1046 41.3856 35.2369 40.9114 35.3677L39.486 35.7474C39.0089 35.8659 38.5329 35.9894 38.0548 36.1039C37.5767 36.2187 37.0983 36.3317 36.6171 36.4338Z'
        fill='#DDB69B'
      />
      <path
        d='M36.5971 37.171C37.0767 37.0163 37.5591 36.8726 38.042 36.7306C38.5248 36.5884 39.01 36.4551 39.4939 36.3168L40.9519 35.9262C41.4391 35.8002 41.9267 35.6758 42.4171 35.5625C41.9376 35.7173 41.4552 35.861 40.9724 36.0031L39.5204 36.4167C39.0343 36.5465 38.5495 36.6813 38.0623 36.8072C37.5751 36.9331 37.0875 37.0576 36.5971 37.171Z'
        fill='#DDB69B'
      />
      <path
        d='M36.6171 37.7932C37.0881 37.6496 37.5617 37.5173 38.0359 37.3865C38.5099 37.2556 38.9861 37.1335 39.4613 37.0065L40.8924 36.6499C41.3705 36.5352 41.849 36.4221 42.3302 36.3203C41.8593 36.464 41.3856 36.5963 40.9114 36.7271L39.486 37.1068C39.0089 37.2253 38.5329 37.3488 38.0548 37.4633C37.5767 37.5781 37.0983 37.6911 36.6171 37.7932Z'
        fill='#DDB69B'
      />
      <path
        d='M36.5971 38.5224C37.0767 38.3677 37.5591 38.2241 38.042 38.0821C38.5248 37.9398 39.01 37.8065 39.4939 37.6684L40.9519 37.2778C41.4391 37.1518 41.9267 37.0273 42.4171 36.9141C41.9376 37.0689 41.4552 37.2126 40.9724 37.3547L39.5204 37.7682C39.0343 37.8981 38.5495 38.0329 38.0623 38.1587C37.5751 38.2847 37.0875 38.409 36.5971 38.5224Z'
        fill='#DDB69B'
      />
      <path
        d='M36.6577 39.4198C37.1244 39.255 37.5944 39.101 38.0648 38.9487C38.5352 38.7962 39.0081 38.6526 39.4796 38.5041L40.9012 38.0824C41.3763 37.9461 41.8519 37.8113 42.3307 37.6875C41.8639 37.8524 41.3941 38.0064 40.9237 38.1588L39.5088 38.6033C39.0349 38.7435 38.5624 38.8887 38.0872 39.0248C37.612 39.161 37.1364 39.2959 36.6577 39.4198Z'
        fill='#DDB69B'
      />
      <path
        d='M36.7783 40.2312C37.2415 40.0485 37.7082 39.8765 38.1755 39.7062C38.6428 39.5356 39.1129 39.3738 39.5815 39.2073L40.995 38.731C41.4676 38.5764 41.9407 38.4234 42.4173 38.2812C41.9542 38.4641 41.4873 38.6361 41.02 38.8064L39.614 39.3052C39.1427 39.4636 38.6731 39.6267 38.2004 39.7812C37.7278 39.9359 37.2549 40.0889 36.7783 40.2312Z'
        fill='#DDB69B'
      />
      <path
        d='M0.515076 33.5832L6.20256 32.5547L41.5656 33.0689L37.3932 34.1865L0.515076 33.5832Z'
        fill='#F193AB'
      />
      <path
        d='M37.3931 41.4035C37.3931 41.4035 43.3462 39.122 43.3663 38.9159C43.3865 38.7098 42.7404 38.5451 42.3971 38.6069C42.0538 38.6688 37.2294 40.6088 37.2294 40.6088L37.3931 41.4035Z'
        fill='#F193AB'
      />
      <path
        d='M0.515494 33.5938L37.3936 34.1972C37.3936 34.1972 36.5488 37.9043 37.3936 41.3957L0.515494 40.4475C0.515494 40.4475 -0.498387 37.1714 0.515494 33.5938Z'
        fill='#DD5881'
      />
      <path
        d='M1.30659 34.7969L36.0356 35.2144C36.0356 35.2144 35.2399 37.7797 36.0356 40.1957L1.30659 39.5395C1.30659 39.5395 0.351859 37.2727 1.30659 34.7969Z'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M0.515076 33.5938L37.3932 34.1971'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M0.515076 40.4375L37.3113 41.3779'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M37.3154 34.5859C37.3154 34.5859 36.5517 38.6056 37.3935 41.0431'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M0.434417 33.8984C0.434417 33.8984 -0.353 37.8387 0.488833 40.276'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M34.3326 36.7302L3.45149 36.5938L2.37494 37.3639L3.45149 38.1444L34.3326 38.3589L32.9338 37.4764L34.3326 36.7302Z'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M43.2602 38.9922L37.4536 41.3732'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.33051 26.695L6.82019 25.6659H42.6458C42.6458 25.6659 42.5808 25.4688 42.6458 25.4688C42.7108 25.4688 43.8561 26.3503 43.8561 26.3503L5.33051 26.695Z'
        fill='#946DA3'
      />
      <path
        d='M5.33082 26.7043L43.8564 26.3594C43.8564 26.3594 44.997 29.5061 43.8564 33.17H5.33082C5.33082 33.17 4.52811 29.3768 5.33082 26.7043Z'
        fill='#BF99CA'
      />
      <path
        d='M43.3385 28.4598C42.8851 28.4598 42.5175 28.0866 42.5136 27.625H6.78717C6.78351 28.0689 6.44321 28.4299 6.0141 28.4572L6.0141 31.4945C6.44564 31.522 6.78757 31.8868 6.78757 32.3339C6.78757 32.3389 6.7869 32.3436 6.7869 32.3485H42.514C42.514 32.3436 42.5133 32.3389 42.5133 32.3339C42.5133 31.8688 42.8827 31.4917 43.3385 31.4917C43.3479 31.4917 43.3573 31.4928 43.3668 31.4931L43.3668 28.4585C43.3573 28.4587 43.3479 28.4598 43.3385 28.4598Z'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.8615 31.1643H8.65474C7.9744 31.1643 7.42279 30.6015 7.42279 29.9072L7.42279 29.7024C7.42279 29.0082 7.9744 28.4453 8.65474 28.4453H10.8615C11.5418 28.4453 12.0934 29.0082 12.0934 29.7024L12.0934 29.9072C12.0934 30.6015 11.5419 31.1643 10.8615 31.1643Z'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M41.1612 29.2422H13.9374L13.9374 30.3446H41.1612L41.1612 29.2422Z'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.99847 26.6938L43.3671 26.3594'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.5473 33.1641H43.6108'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2.5932 19.5469L2.5932 25.2829L6.82037 25.6764C6.82037 25.6764 8.06627 20.7646 6.92419 19.6528L2.5932 19.5469Z'
        fill='#F4E6DC'
      />
      <path
        d='M6.92419 19.6528L2.5932 19.5469L2.5932 19.9914C2.75198 20.0061 2.91077 20.0224 3.06874 20.045C3.50407 20.107 3.92316 20.2209 4.32776 20.3968C4.9943 20.6863 5.63133 21.0949 6.10131 21.6648C6.33631 21.9497 6.52541 22.272 6.65089 22.6221C6.79045 23.0115 6.84365 23.4327 6.85962 23.8454C6.87668 24.2849 6.84433 24.7271 6.76663 25.1597C6.73617 25.3293 6.69597 25.4957 6.64995 25.6605L6.8201 25.6764C6.82037 25.6764 8.06627 20.7646 6.92419 19.6528Z'
        fill='#EDD5C5'
      />
      <path
        d='M2.93695 20.1688C3.33357 20.1474 3.73019 20.1375 4.12667 20.1292C4.52329 20.1206 4.91991 20.1215 5.31639 20.1172C5.71301 20.1212 6.10963 20.1208 6.50625 20.1291C6.90286 20.1374 7.29948 20.1474 7.69597 20.1688C7.29935 20.1904 6.90273 20.2003 6.50625 20.2086C6.10963 20.2169 5.71301 20.2165 5.31639 20.2205C4.91977 20.2162 4.52315 20.2169 4.12667 20.2085C3.73005 20.2002 3.33343 20.1901 2.93695 20.1688Z'
        fill='#DDB69B'
      />
      <path
        d='M2.93695 20.6923C3.33357 20.6709 3.73019 20.6609 4.12667 20.6526C4.52329 20.6441 4.91991 20.6449 5.31639 20.6406C5.71301 20.6446 6.10963 20.6442 6.50625 20.6525C6.90286 20.6608 7.29948 20.6709 7.69597 20.6923C7.29935 20.7138 6.90273 20.7238 6.50625 20.7321C6.10963 20.7404 5.71301 20.7399 5.31639 20.7439C4.91977 20.7397 4.52315 20.7404 4.12667 20.7319C3.73005 20.7236 3.33343 20.7137 2.93695 20.6923Z'
        fill='#DDB69B'
      />
      <path
        d='M2.93695 21.2001C3.33357 21.1787 3.73019 21.1687 4.12667 21.1605C4.52329 21.1519 4.91991 21.1527 5.31639 21.1484C5.71301 21.1524 6.10963 21.152 6.50625 21.1603C6.90286 21.1687 7.29948 21.1787 7.69597 21.2002C7.29935 21.2218 6.90273 21.2317 6.50625 21.24C6.10963 21.2483 5.71301 21.2479 5.31639 21.2519C4.91977 21.2476 4.52315 21.2483 4.12667 21.2399C3.73005 21.2315 3.33343 21.2215 2.93695 21.2001Z'
        fill='#DDB69B'
      />
      <path
        d='M2.93695 21.7002C3.33357 21.6788 3.73019 21.6689 4.12667 21.6606C4.52329 21.652 4.91991 21.6529 5.31639 21.6484C5.71301 21.6524 6.10963 21.652 6.50625 21.6603C6.90286 21.6686 7.29948 21.6787 7.69597 21.7001C7.29935 21.7216 6.90273 21.7316 6.50625 21.7399C6.10963 21.7482 5.71301 21.7478 5.31639 21.7518C4.91977 21.7475 4.52315 21.7482 4.12667 21.7397C3.73005 21.7317 3.33343 21.7216 2.93695 21.7002Z'
        fill='#DDB69B'
      />
      <path
        d='M2.93695 22.2001C3.33357 22.1787 3.73019 22.1687 4.12667 22.1605C4.52329 22.1519 4.91991 22.1527 5.31639 22.1484C5.71301 22.1524 6.10963 22.152 6.50625 22.1603C6.90286 22.1686 7.29948 22.1787 7.69597 22.2001C7.29935 22.2216 6.90273 22.2316 6.50625 22.2399C6.10963 22.2482 5.71301 22.2478 5.31639 22.2518C4.91977 22.2475 4.52315 22.2482 4.12667 22.2397C3.73005 22.2315 3.33343 22.2215 2.93695 22.2001Z'
        fill='#DDB69B'
      />
      <path
        d='M2.93695 22.7159C3.33357 22.6945 3.73019 22.6845 4.12667 22.6762C4.52329 22.6677 4.91991 22.6685 5.31639 22.6641C5.71301 22.6681 6.10963 22.6677 6.50625 22.6759C6.90286 22.6844 7.29948 22.6943 7.69597 22.7157C7.29935 22.7373 6.90273 22.7472 6.50625 22.7555C6.10963 22.7638 5.71301 22.7634 5.31639 22.7674C4.91977 22.7631 4.52315 22.7638 4.12667 22.7552C3.73005 22.7472 3.33343 22.7371 2.93695 22.7159Z'
        fill='#DDB69B'
      />
      <path
        d='M2.93695 23.2235C3.33357 23.2021 3.73019 23.1922 4.12667 23.1839C4.52329 23.1753 4.91991 23.1762 5.31639 23.1719C5.71301 23.1759 6.10963 23.1755 6.50625 23.1838C6.90286 23.192 7.29948 23.2021 7.69597 23.2235C7.29935 23.2451 6.90273 23.255 6.50625 23.2633C6.10963 23.2716 5.71301 23.2712 5.31639 23.2752C4.91977 23.2709 4.52315 23.2716 4.12667 23.2632C3.73005 23.255 3.33343 23.2449 2.93695 23.2235Z'
        fill='#DDB69B'
      />
      <path
        d='M2.93695 23.7335C3.33411 23.7241 3.731 23.7259 4.12789 23.7295C4.52478 23.7328 4.92126 23.7455 5.31801 23.7531C5.7145 23.7691 6.11112 23.7806 6.50746 23.8007C6.90381 23.821 7.30016 23.8429 7.6961 23.8763C7.29894 23.886 6.90205 23.884 6.50516 23.8804C6.10827 23.8768 5.71179 23.8644 5.31504 23.8567C4.91855 23.8404 4.52194 23.8293 4.12559 23.8089C3.72924 23.7886 3.33289 23.7668 2.93695 23.7335Z'
        fill='#DDB69B'
      />
      <path
        d='M2.93695 24.2394C3.33425 24.2312 3.73113 24.2344 4.12802 24.2394C4.52491 24.2441 4.9214 24.258 5.31815 24.267C5.71463 24.2843 6.11125 24.2971 6.5076 24.3185C6.90395 24.3401 7.30016 24.3633 7.6961 24.3981C7.29881 24.4064 6.90192 24.403 6.50503 24.3982C6.10814 24.3932 5.71166 24.3796 5.3149 24.3704C4.91842 24.3529 4.5218 24.3405 4.12545 24.3187C3.7291 24.2971 3.33276 24.2739 2.93695 24.2394Z'
        fill='#DDB69B'
      />
      <path
        d='M2.93695 24.7502C3.33452 24.7486 3.73168 24.7584 4.12857 24.77C4.52559 24.7814 4.92207 24.802 5.31896 24.8176C5.71531 24.8415 6.11193 24.8609 6.50814 24.889C6.90435 24.9172 7.30043 24.947 7.69597 24.9883C7.2984 24.9899 6.90124 24.98 6.50422 24.9685C6.10719 24.9569 5.71071 24.9368 5.31382 24.9209C4.91747 24.8967 4.52085 24.8776 4.12464 24.8493C3.72856 24.8212 3.33249 24.7913 2.93695 24.7502Z'
        fill='#DDB69B'
      />
      <path
        d='M6.77238 19.7587H1.65925C1.65925 19.7587 1.48125 19.1875 2.07455 19.1875C2.66785 19.1875 6.48054 19.1875 6.48054 19.1875L6.77238 19.7587Z'
        fill='#DD5881'
      />
      <path
        d='M6.70645 25.4206L1.79258 25.0547C1.79258 25.0547 1.64422 25.4785 1.95569 25.5542C2.26716 25.6299 5.57466 25.9015 5.57466 25.9015H6.48039L6.70645 25.4206Z'
        fill='#DD5881'
      />
      <path
        d='M1.95551 25.5469L6.17469 25.8943'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.65912 19.7578H6.77225'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2.22064 19.1875H6.77269'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.48041 19.1875H43.6582'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.48041 19.1875H43.6582C43.6582 19.1875 44.87 21.9256 43.6582 25.9003H6.48041C6.48041 25.9003 7.47588 21.7489 6.48041 19.1875Z'
        fill='#F193AB'
      />
      <path
        d='M7.05121 19.4688C7.05121 19.4688 7.84228 21.877 7.05121 25.7223'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.40277 19.4688C7.40277 19.4688 8.19384 21.877 7.40277 25.7223'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.1987 19.4688C12.1987 19.4688 12.9897 21.877 12.1987 25.7223'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.5502 19.4688C12.5502 19.4688 13.3413 21.877 12.5502 25.7223'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.1377 25.7223C10.9287 21.877 10.1377 19.4688 10.1377 19.4688H9.09467C9.09467 19.4688 9.88574 21.877 9.09467 25.7223H10.1377Z'
        fill='#521618'
      />
      <path
        d='M15.6606 25.7223C16.4517 21.877 15.6606 19.4688 15.6606 19.4688H14.6176C14.6176 19.4688 15.4087 21.877 14.6176 25.7223H15.6606Z'
        fill='#521618'
      />
      <path
        d='M20.7695 25.7223C21.5606 21.877 20.7695 19.4688 20.7695 19.4688H19.7265C19.7265 19.4688 20.5176 21.877 19.7265 25.7223H20.7695Z'
        fill='#521618'
      />
      <path
        d='M25.727 25.7223C26.5181 21.877 25.727 19.4688 25.727 19.4688H24.684C24.684 19.4688 25.4751 21.877 24.684 25.7223H25.727Z'
        fill='#521618'
      />
      <path
        d='M30.8437 25.7223C31.6348 21.877 30.8437 19.4688 30.8437 19.4688H29.8007C29.8007 19.4688 30.5918 21.877 29.8007 25.7223H30.8437Z'
        fill='#521618'
      />
      <path
        d='M36.1684 25.7223C36.9595 21.877 36.1684 19.4688 36.1684 19.4688H35.1254C35.1254 19.4688 35.9165 21.877 35.1254 25.7223H36.1684Z'
        fill='#521618'
      />
      <path
        d='M41.6753 25.7223C42.4663 21.877 41.6753 19.4688 41.6753 19.4688H40.6323C40.6323 19.4688 41.4233 21.877 40.6323 25.7223H41.6753Z'
        fill='#521618'
      />
      <path
        d='M17.3461 19.4688C17.3461 19.4688 18.1372 21.877 17.3461 25.7223'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.6977 19.4688C17.6977 19.4688 18.4888 21.877 17.6977 25.7223'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M22.4936 19.4688C22.4936 19.4688 23.2847 21.877 22.4936 25.7223'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M22.8452 19.4688C22.8452 19.4688 23.6362 21.877 22.8452 25.7223'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M27.6411 19.4688C27.6411 19.4688 28.4321 21.877 27.6411 25.7223'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M27.9926 19.4688C27.9926 19.4688 28.7837 21.877 27.9926 25.7223'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M32.7885 19.4688C32.7885 19.4688 33.5796 21.877 32.7885 25.7223'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M33.1401 19.4688C33.1401 19.4688 33.9311 21.877 33.1401 25.7223'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M37.936 19.4688C37.936 19.4688 38.727 21.877 37.936 25.7223'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M38.2875 19.4688C38.2875 19.4688 39.0786 21.877 38.2875 25.7223'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M43.0834 19.4688C43.0834 19.4688 43.8745 21.877 43.0834 25.7223'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M43.435 19.4688C43.435 19.4688 44.2261 21.877 43.435 25.7223'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.05121 25.8906H43.6582'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.1264 12.3346L5.54286 11.8125L10.0654 12.3346H4.1264Z'
        fill='#6D9B71'
      />
      <path
        d='M4.12667 12.3438C4.12667 12.3438 2.9846 15.5254 4.12667 19.1891H42.6462C42.6462 19.1891 43.8148 15.8326 42.6462 12.3438H4.12667Z'
        fill='#A2CAA7'
      />
      <path
        d='M4.1264 19.1875H42.6459'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.72139 12.6953C4.72139 12.6953 3.78697 15.793 4.72139 18.8117'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.21944 12.6953C5.21944 12.6953 4.28501 15.793 5.21944 18.8117'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M42.3168 18.8117C42.3168 18.8117 43.2513 15.7141 42.3168 12.6953'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M41.8188 18.8117C41.8188 18.8117 42.7532 15.7141 41.8188 12.6953'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M39.7533 14.7812H7.36957L7.36957 16.7363H39.7533L39.7533 14.7812Z'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.2561 5.15714H1.63519L1.63519 0.827677L13.2561 0.40625L13.2561 5.15714Z'
        fill='#F4E6DC'
      />
      <path
        d='M1.63519 0.827677L1.63519 2.05894C2.62403 1.91515 3.62248 1.84512 4.6208 1.81335C5.60909 1.78186 6.60172 1.79581 7.57919 1.96363C8.51212 2.12372 9.47782 2.4247 10.2165 3.05208C10.8386 3.58041 11.2001 4.35172 11.3287 5.15714H13.2561L13.2561 0.40625L1.63519 0.827677Z'
        fill='#EDD5C5'
      />
      <path
        d='M1.63519 1.46219L2.98518 1.38125L4.33572 1.31094L7.03719 1.18718L9.73961 1.08745L11.0911 1.04615L12.4431 1.01562L11.0931 1.09684L9.74272 1.16715L7.04125 1.29064L4.33883 1.39023L2.98722 1.43153L1.63519 1.46219Z'
        fill='#DDB69B'
      />
      <path
        d='M1.63519 1.87427L3.0109 1.79637L4.38689 1.72938L7.13939 1.61197L9.89285 1.5186L11.2699 1.48047L12.6474 1.45312L11.2718 1.53117L9.89582 1.5983L7.14318 1.71543L4.38973 1.80866L3.01266 1.84679L1.63519 1.87427Z'
        fill='#DDB69B'
      />
      <path
        d='M1.63519 2.35378L2.99615 2.2883L4.35738 2.23347L7.08024 2.14078L9.80377 2.072L11.1657 2.04617L12.528 2.03125L11.1672 2.09686L9.80594 2.1517L7.08308 2.24424L4.35954 2.31275L2.9975 2.33858L1.63519 2.35378Z'
        fill='#DDB69B'
      />
      <path
        d='M1.63525 2.75057L2.98565 2.68731L4.33619 2.63455L7.03779 2.54614L9.74021 2.48178L11.0916 2.45802L12.4432 2.44531L11.0929 2.50871L9.74238 2.56148L7.04064 2.6496L4.33835 2.71383L2.98701 2.73759L1.63525 2.75057Z'
        fill='#DDB69B'
      />
      <path
        d='M1.63519 3.13543L2.98559 3.07673L4.33626 3.0288L7.038 2.94965L9.74029 2.8944L11.0915 2.87534L12.4431 2.86719L11.0927 2.92603L9.74218 2.9741L7.04044 3.05311L4.33816 3.10808L2.98681 3.12714L1.63519 3.13543Z'
        fill='#DDB69B'
      />
      <path
        d='M1.63519 3.58131L2.96298 3.5157L4.29105 3.46086L6.94758 3.3679L9.60479 3.29897L10.9337 3.27301L12.2628 3.25781L10.9352 3.3237L9.60709 3.37854L6.95056 3.47136L4.29335 3.54014L2.96447 3.56611L1.63519 3.58131Z'
        fill='#DDB69B'
      />
      <path
        d='M1.63519 4.77257L2.986 4.73721L4.33694 4.71262L7.03882 4.6803L9.74083 4.67188L11.092 4.67616L12.4431 4.69135L11.0923 4.72685L9.74151 4.75157L7.03963 4.78376L4.33748 4.79191L2.9864 4.78763L1.63519 4.77257Z'
        fill='#DDB69B'
      />
      <path
        d='M12.3822 4.29727L11.039 4.33429L9.69575 4.36053L7.00917 4.39631L4.32232 4.40805L2.97882 4.40543L1.63519 4.39189L2.97842 4.35473L4.32164 4.32835L7.00822 4.29285L9.69508 4.28125L11.0386 4.28387L12.3822 4.29727Z'
        fill='#DDB69B'
      />
      <path
        d='M1.63519 4.01733L2.98573 3.96456L4.3364 3.92257L7.03814 3.8553L9.74042 3.81221L11.0916 3.79908L12.4431 3.79688L11.0927 3.84978L9.74191 3.89177L7.04017 3.95876L4.33802 4.00186L2.98667 4.01498L1.63519 4.01733Z'
        fill='#DDB69B'
      />
      <path
        d='M1.39959 0.590809C1.30456 0.594953 1.21468 0.644679 1.16663 0.728522C1.10734 0.831565 1.0513 1.09083 1.27451 1.09083L12.7339 0.688189L12.4437 0.101562L1.39959 0.590809Z'
        fill='#87ACAF'
      />
      <path
        d='M12.4303 5.6174H1.30524C1.17353 5.6174 1.05008 5.54115 0.998231 5.41766C0.997689 5.41656 0.997284 5.41532 0.996743 5.41421C0.909432 5.2026 1.06524 4.96875 1.29021 4.96875C2.66389 4.96875 12.1068 4.96875 12.7362 4.96875C12.7519 4.96875 12.7607 4.9856 12.7536 4.99983L12.4489 5.60579C12.4453 5.61298 12.4382 5.6174 12.4303 5.6174Z'
        fill='#87ACAF'
      />
      <path
        d='M12.4365 0.101562L44.9305 0.89096C45.0738 0.894413 45.2037 0.980604 45.262 1.11417C45.5061 1.67262 46.0343 3.2539 45.303 5.25481C45.2219 5.47678 45.0106 5.62196 44.7785 5.62196H12.4365C12.4365 5.62196 13.6484 2.79546 12.4365 0.101562Z'
        fill='#A0C9CF'
      />
      <path
        d='M44.4468 2.00583C44.1802 2.00583 43.9643 1.7938 43.9467 1.52639L13.9169 0.984375C13.9098 1.21173 13.7584 1.4 13.5527 1.45995C13.7565 2.54646 13.6367 3.70037 13.5346 4.34708C13.7546 4.40206 13.9185 4.60317 13.9185 4.84462C13.9185 4.85152 13.9167 4.85788 13.9165 4.86465H44.0287C44.0282 4.85553 44.026 4.84697 44.026 4.83771C44.026 4.554 44.2514 4.32402 44.5295 4.32402C44.5943 4.32402 44.6559 4.33755 44.7127 4.36034C45.147 3.2911 44.9105 2.418 44.6922 1.93814C44.6193 1.98 44.5364 2.00583 44.4468 2.00583Z'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.4365 0.101562C12.5203 0.29867 13.6125 2.3569 12.4365 5.74185'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.6636 0.703125L1.63519 1.10314'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.48334 4.96875H12.6063'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.95306 5.98438L5.95306 11.7204L10.1802 12.1139C10.1802 12.1139 11.4261 7.2021 10.2841 6.09032L5.95306 5.98438Z'
        fill='#F4E6DC'
      />
      <path
        d='M10.2841 6.09032L5.95306 5.98438L5.95306 6.42887C6.11198 6.44365 6.27063 6.45995 6.4286 6.48246C6.86393 6.54448 7.28302 6.65844 7.68763 6.83413C8.35416 7.12365 8.99119 7.53223 9.46118 8.10214C9.69617 8.3871 9.88527 8.70935 10.0108 9.0595C10.1503 9.44888 10.2035 9.87003 10.2195 10.2828C10.2365 10.7223 10.2042 11.1644 10.1265 11.597C10.096 11.7667 10.0558 11.9331 10.0098 12.0979L10.18 12.1138C10.18 12.1138 11.426 7.2021 10.2841 6.09032Z'
        fill='#EDD5C5'
      />
      <path
        d='M6.29681 6.62197C6.69343 6.60056 7.09005 6.59062 7.48654 6.58233C7.88315 6.57377 8.27977 6.57459 8.67625 6.57031C9.07287 6.57432 9.46949 6.5739 9.86611 6.58219C10.2627 6.59048 10.6593 6.60056 11.056 6.62211C10.6593 6.64366 10.2627 6.6536 9.86611 6.66189C9.46949 6.67018 9.07287 6.66976 8.67625 6.67377C8.27964 6.66949 7.88302 6.67018 7.48654 6.66175C7.08992 6.65333 6.6933 6.64338 6.29681 6.62197Z'
        fill='#DDB69B'
      />
      <path
        d='M6.29681 7.12211C6.69343 7.1007 7.09005 7.09075 7.48654 7.08247C7.88315 7.0739 8.27977 7.07473 8.67625 7.07031C9.07287 7.07432 9.46949 7.0739 9.86611 7.08219C10.2627 7.09062 10.6593 7.10056 11.056 7.12197C10.6593 7.14352 10.2627 7.15347 9.86611 7.16175C9.46949 7.17004 9.07287 7.16963 8.67625 7.17363C8.27964 7.16935 7.88302 7.17004 7.48654 7.16148C7.08992 7.15347 6.6933 7.14352 6.29681 7.12211Z'
        fill='#DDB69B'
      />
      <path
        d='M6.29681 7.62978C6.69343 7.60837 7.09005 7.59843 7.48654 7.59014C7.88315 7.58158 8.27977 7.58241 8.67625 7.57812C9.07287 7.58213 9.46949 7.58172 9.86611 7.59C10.2627 7.59829 10.6593 7.60837 11.056 7.62978C10.6593 7.65133 10.2627 7.66128 9.86611 7.6697C9.46949 7.67799 9.07287 7.67758 8.67625 7.68158C8.27964 7.6773 7.88302 7.67799 7.48654 7.66957C7.08992 7.66128 6.6933 7.65119 6.29681 7.62978Z'
        fill='#DDB69B'
      />
      <path
        d='M6.29681 8.1376C6.69343 8.11619 7.09005 8.10624 7.48654 8.09795C7.88315 8.08939 8.27977 8.09022 8.67625 8.08594C9.07287 8.08994 9.46949 8.08953 9.86611 8.09782C10.2627 8.10624 10.6593 8.11619 11.056 8.13774C10.6593 8.15928 10.2627 8.16923 9.86611 8.17752C9.46949 8.1858 9.07287 8.18539 8.67625 8.18939C8.27964 8.18511 7.88302 8.1858 7.48654 8.17738C7.08992 8.16895 6.6933 8.15901 6.29681 8.1376Z'
        fill='#DDB69B'
      />
      <path
        d='M6.29681 8.65322C6.69343 8.63181 7.09005 8.62187 7.48654 8.61358C7.88315 8.60502 8.27977 8.60584 8.67625 8.60156C9.07287 8.60557 9.46949 8.60515 9.86611 8.61344C10.2627 8.62187 10.6593 8.63181 11.056 8.65322C10.6593 8.67477 10.2627 8.68472 9.86611 8.69314C9.46949 8.70143 9.07287 8.70101 8.67625 8.70502C8.27964 8.70074 7.88302 8.70143 7.48654 8.693C7.08992 8.68458 6.6933 8.67449 6.29681 8.65322Z'
        fill='#DDB69B'
      />
      <path
        d='M6.29681 9.15322C6.69343 9.13181 7.09005 9.12187 7.48654 9.11358C7.88315 9.10502 8.27977 9.10584 8.67625 9.10156C9.07287 9.10557 9.46949 9.10515 9.86611 9.11344C10.2627 9.12173 10.6593 9.13181 11.056 9.15322C10.6593 9.17477 10.2627 9.18472 9.86611 9.193C9.46949 9.20129 9.07287 9.20088 8.67625 9.20488C8.27964 9.2006 7.88302 9.20129 7.48654 9.19286C7.08992 9.18471 6.6933 9.17463 6.29681 9.15322Z'
        fill='#DDB69B'
      />
      <path
        d='M6.29681 9.66885C6.69343 9.64744 7.09005 9.63749 7.48654 9.62921C7.88315 9.62064 8.27977 9.62147 8.67625 9.61719C9.07287 9.62119 9.46949 9.62078 9.86611 9.62907C10.2627 9.63749 10.6593 9.64744 11.056 9.66885C10.6593 9.69039 10.2627 9.70034 9.86611 9.70863C9.46949 9.71692 9.07287 9.7165 8.67625 9.72051C8.27964 9.71622 7.88302 9.71691 7.48654 9.70849C7.08992 9.7002 6.6933 9.69026 6.29681 9.66885Z'
        fill='#DDB69B'
      />
      <path
        d='M6.29681 10.1788C6.69397 10.1694 7.09086 10.1712 7.48775 10.1748C7.88464 10.1781 8.28113 10.1908 8.67788 10.1984C9.07436 10.2144 9.47098 10.2259 9.86733 10.2461C10.2637 10.2664 10.66 10.2882 11.056 10.3216C10.6587 10.3313 10.2619 10.3292 9.86503 10.3258C9.46814 10.322 9.07165 10.3097 8.6749 10.3019C8.27842 10.2856 7.8818 10.2745 7.48545 10.2541C7.0891 10.2339 6.69276 10.2119 6.29681 10.1788Z'
        fill='#DDB69B'
      />
      <path
        d='M6.29681 10.6847C6.69411 10.6765 7.091 10.6797 7.48789 10.6847C7.88478 10.6894 8.28126 10.7033 8.67801 10.7123C9.0745 10.7296 9.47112 10.7424 9.86746 10.7638C10.2638 10.7854 10.66 10.8086 11.056 10.8434C10.6587 10.8517 10.2618 10.8484 9.86489 10.8435C9.468 10.8386 9.07152 10.8249 8.67477 10.8158C8.27828 10.7982 7.88166 10.7858 7.48532 10.764C7.08897 10.7426 6.69262 10.7193 6.29681 10.6847Z'
        fill='#DDB69B'
      />
      <path
        d='M6.29681 11.1877C6.69438 11.1861 7.09154 11.1959 7.48857 11.2075C7.88559 11.2189 8.28207 11.2395 8.67896 11.2551C9.07531 11.279 9.47193 11.2984 9.86814 11.3265C10.2644 11.3547 10.6604 11.3845 11.056 11.4258C10.6583 11.4274 10.2612 11.4175 9.86421 11.406C9.46719 11.3944 9.07071 11.3741 8.67382 11.3584C8.27747 11.3342 7.88085 11.3151 7.48464 11.2868C7.08843 11.2587 6.69235 11.2288 6.29681 11.1877Z'
        fill='#DDB69B'
      />
      <path
        d='M10.1318 6.19616H5.01863C5.01863 6.19616 4.84062 5.625 5.43392 5.625C6.02723 5.625 9.83991 5.625 9.83991 5.625L10.1318 6.19616Z'
        fill='#BD5E2E'
      />
      <path
        d='M10.0658 11.8503L5.15195 11.4844C5.15195 11.4844 5.00359 11.9081 5.31506 11.9838C5.62654 12.0595 8.93404 12.3312 8.93404 12.3312H9.83976L10.0658 11.8503Z'
        fill='#BD5E2E'
      />
      <path
        d='M5.31488 11.9922L9.53406 12.3394'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.01849 6.19531H10.1316'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.57953 5.625H10.1316'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.84027 5.625H47.018C47.018 5.625 48.23 8.3631 47.018 12.3378H9.84027C9.84027 12.3378 10.8357 8.18657 9.84027 5.625Z'
        fill='#E28329'
      />
      <path
        d='M9.84027 5.625H47.018'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.4106 5.92188C10.4106 5.92188 11.2017 8.33012 10.4106 12.1754'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.7617 5.92188C10.7617 5.92188 11.5527 8.33012 10.7617 12.1754'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.558 5.92188C15.558 5.92188 16.3491 8.33012 15.558 12.1754'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.9096 5.92188C15.9096 5.92188 16.7007 8.33012 15.9096 12.1754'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M20.7055 5.92188C20.7055 5.92188 21.4966 8.33012 20.7055 12.1754'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M21.0571 5.92188C21.0571 5.92188 21.8481 8.33012 21.0571 12.1754'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M25.853 5.92188C25.853 5.92188 26.644 8.33012 25.853 12.1754'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M26.2045 5.92188C26.2045 5.92188 26.9956 8.33012 26.2045 12.1754'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M31.0004 5.92188C31.0004 5.92188 31.7915 8.33012 31.0004 12.1754'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M31.352 5.92188C31.352 5.92188 32.1431 8.33012 31.352 12.1754'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M36.1479 5.92188C36.1479 5.92188 36.939 8.33012 36.1479 12.1754'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M36.4995 5.92188C36.4995 5.92188 37.2905 8.33012 36.4995 12.1754'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M41.2953 5.92188C41.2953 5.92188 42.0864 8.33012 41.2953 12.1754'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M41.6469 5.92188C41.6469 5.92188 42.438 8.33012 41.6469 12.1754'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M46.4428 5.92188C46.4428 5.92188 47.2339 8.33012 46.4428 12.1754'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M46.7944 5.92188C46.7944 5.92188 47.5854 8.33012 46.7944 12.1754'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.30658 12.3438H42.2757'
        stroke='#521618'
        strokeWidth='0.2'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default ForSchools;
